<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import router from "@/router";
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(
      "window.location.host",
      `${window.location.protocol}//${window.location.host}/#/`
    );
    console.log(
      "window.location.href",
      window.location.href,
      "this.$route.path",
      this.$route.path
    );
    //判断是否手机端
    if (this.isMobile()) {
      console.log("手机端");
      //跳转到对应的路由地址
      if (
        `${window.location.protocol}//${window.location.host}/#/` ===
        window.location.href
      ) {
        router
          .replace({
            path: "/index_m"
          })
          .catch(err => {
            console.log(err);
          });
      } else {
          let path=this.$route.path;
        if(path.indexOf('_m')===-1){
          path=`${this.$route.path}_m`
        }
        router
          .replace({
            path,
          })
          .catch(err => {
            console.log(err);
          });
      }
    } else {
      console.log("pc端");
      //跳转到对应的路由地址
      if (
        `${window.location.protocol}//${window.location.host}/#/` ===
        window.location.href
      ) {
        router
          .replace({
            path: "/"
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        
        let path=this.$route.path;
        if(path.indexOf('_m')!==-1){
          if(this.$route.path==='/index_m'){
              path='/';
          }else{
             path=path.slice(0,-2);
          }
         
        }
        router
          .replace({
            path,
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style lang="scss">
@import "./style.scss";
</style>